import { ts } from '_core';

import fixedWeights from './fixed-weights';
import gradientBoosting from './gradient-boosting';
import lasso from './lasso';
import linearRegression from './linear-regression';
import optimizedModel from './optimized-model';
import randomForest from './random-forest';
import robust from './robust';

const typeMap: Record<ts.types.signal.AlphaDefinition['alpha_type'], any> = {
  custom: {},
  fixed: fixedWeights,
  gradientBoosting: gradientBoosting,
  lasso: lasso,
  linearRegression: linearRegression,
  optimizedModel: optimizedModel,
  robust: robust,
  randomForest: randomForest,
};

export default typeMap;
